import api from "./api";

// ✅ Fetch all store transactions (ORDERED + DELIVERED still visible)
export const fetchStoresItems = async () => {
  try {
    const res = await api.get("/stores/");
    return res.data;
  } catch (err) {
    console.error("Error fetching store items:", err);
    throw err;
  }
};

/**
 * 🚚 Bulk mark items in a lot as delivered
 * Each item: { id, quantity, remarks }
 * @param {Array} items - Array of objects with id, quantity, remarks
 */
export const bulkMarkDelivered = async (items) => {
  try {
    const res = await api.post("/stores/mark-delivered-bulk/", { items });
    return res.data;
  } catch (err) {
    console.error("Error bulk marking items as delivered:", err);
    throw err;
  }
};

/**
 * ✅ Bulk mark items in a lot as collected
 * Each item: { id, quantity, remarks }
 * @param {Array} items - Array of objects with id, quantity, remarks
 */
export const bulkMarkCollected = async (items) => {
  try {
    const res = await api.post("/stores/mark-collected-bulk/", { items });
    return res.data;
  } catch (err) {
    console.error("Error bulk marking items as collected:", err);
    throw err;
  }
};
